import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function EditSettingDate() {
  const { id } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [newData, setNewData] = useState([{
    date_name: "",
    start_date: "",
    end_date: "",
    updated_by: user.npp,
  }]);
  const [isLoading, setIsLoading] = useState(true);
  const [dataSettingDate, setDataSettingDate] = useState();


  // CONTROLLER

  const fetchEditSettingDate = async (id) => {
    setIsLoading(true);
    await baseAPI
      .get(`/v1/dsetting/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.dataSetting;
        setDataSettingDate(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updateSettingDate = async (id) => {

    Swal.fire({
      title: 'Do you want to update the data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(dataSettingDate));
        body.append('updated_by', user.npp);

        baseAPI
          .put(`/v1/dsetting/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Date data has been updated.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed update the data.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchEditSettingDate(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });

  }


  useEffect(() => {
    setIsLoading(true);
    if (user.role === ADMIN) {
      fetchEditSettingDate(id);
    }
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
              <Link to='/setting/settingdate' style={{ color: '#333' }}>Setting Date</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Edit Setting Date</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Edit Setting Date</b></p>
              </div>

              {/* Nama date */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Date Name
                </label>
                <input
                  defaultValue={dataSettingDate.date_name}
                  className="form-control"
                  onChange={e => setDataSettingDate({...dataSettingDate, date_name: e.target.value})}
                />
              </div>

              {/* Start Date */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Start Date
                </label>
                <input
                  type='number'
                  defaultValue={dataSettingDate.start_date}
                  className="form-control"
                  onChange={e => setDataSettingDate({...dataSettingDate, start_date: e.target.value})}
                />
              </div>

              {/* End Date */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  End Date
                </label>
                <input
                  type='number'
                  defaultValue={dataSettingDate.end_date}
                  className="form-control"
                  onChange={e => setDataSettingDate({...dataSettingDate, end_date: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={dataSettingDate.date_name !== "" && dataSettingDate.start_date !== "" && dataSettingDate.end_date !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updateSettingDate(id)}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default EditSettingDate;